import { render, staticRenderFns } from "./CreateRewardAmountsModal.vue?vue&type=template&id=7e04e704&scoped=true&"
import script from "./CreateRewardAmountsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateRewardAmountsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateRewardAmountsModal.vue?vue&type=style&index=0&id=7e04e704&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e04e704",
  null
  
)

export default component.exports